import { BalancePaymentTranslations } from "./balancePaymentTranslations.types";

const balancePaymentFrTranslations: BalancePaymentTranslations = {
    balancePaymentPage: {
        title: "Paiement du solde",
        loading: "Chargement des informations de paiement...",
        processing: "Traitement de votre paiement...",
        processingDescription: "Veuillez patienter pendant la confirmation de votre paiement.",
        successTitle: "Paiement effectué !",
        successDescription: "Votre paiement de solde a été traité avec succès.",
        errorTitle: "Le paiement n'a pas pu aboutir",
        errorDescription: "Une erreur est survenue lors du traitement de votre paiement. Veuillez réessayer plus tard.",
        fullyPaidTitle: "Tous les paiements sont à jour",
        fullyPaidDescription: "Il n'y a aucun paiement de solde en attente pour cette réservation.",
        noBookingReference: "Aucune référence de réservation fournie.",
        bookingReference: "Référence de réservation",
        departure: "Départ",
        returnDate: "Retour",
        totalPrice: "Prix total",
        amountPaid: "Montant payé",
        balanceDue: "Solde dû",
        amountToPay: "Montant à payer : {amount}",
        paymentModeTitle: "Choisissez votre option de paiement",
        payNextPayment: "Payer le prochain versement",
        payFullBalance: "Payer la totalité du solde",
    },
};

export default balancePaymentFrTranslations;
